import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, getCurrentUser, isClient } from '../auth';

interface RequireAuthProps {
  children: React.ReactNode;
}

interface RequireAdminProps {
  children: React.ReactNode;
}

interface RequireClientAuthProps {
  children: React.ReactNode;
}

export const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const isClientUser = isClient();

  if (isClientUser) {
    return <Navigate to="/client/dashboard" replace />;
  }

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

export const RequireAdmin: React.FC<RequireAdminProps> = ({ children }) => {
  const isClientUser = isClient();

  if (isClientUser) {
    return <Navigate to="/client/dashboard" replace />;
  }

  const currentUser = getCurrentUser();
  const role = currentUser?.role;

  if (role === 'MANAGER' || role === 'SALES') {
    return <Navigate to="/leads" replace />;
  }
  return <>{children}</>;
};

export const RequireAdminOrSales: React.FC<RequireAdminProps> = ({ children }) => {
  const isClientUser = isClient();

  if (isClientUser) {
    return <Navigate to="/client/dashboard" replace />;
  }

  const currentUser = getCurrentUser();
  const role = currentUser?.role;

  if (role !== 'ADMIN' && role !== 'SALES') {
    return <Navigate to="/leads" replace />;
  }
  return <>{children}</>;
};

export const RequireClientAuth: React.FC<RequireClientAuthProps> = ({ children }) => {
  const isClientUser = isClient();

  if (!isClientUser) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};
